import React, { Component } from "react";
import {
  DataGrid,
  GridColumn,
  Panel,
  DateBox,
  ComboBox,
  LinkButton,
} from "rc-easyui";
import PropTypes from "prop-types";
import { API_URL } from "../../../constants";
import { getCookie, getAccessToken } from "../../../helpers/cookieHelper";
import { isEmpty, getFormattedDate } from "../../../helpers";

const axios = require("axios");

export default class ViewClientPayment extends Component {
  static propTypes = {
    selectedRow: PropTypes.object,
    OnEditClick: PropTypes.func,
    onSelectionChange: PropTypes.func,
    permissions: PropTypes.array,
    clientsList: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.refereshData = this.refereshData.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.searchFieldOnChange = this.searchFieldOnChange.bind(this);
    this.getClientPaymentInfo = this.getClientPaymentInfo.bind(this);

    this.state = {
      data: [],
      pageOptions: {},
      searchparam: {
        srchClient: null,
        toDate: new Date(),
        formDate: new Date(),
      },
    };
  }

  componentDidMount() {
    this.setState(
      {
        pageOptions: {
          loading: true,

          pageOptions: {
            pageNumber: 1,
            pageSize: 10,
            layout: [
              "list",
              "sep",
              "first",
              "prev",
              "next",
              "last",
              "sep",
              "refresh",
              "sep",
              "manual",
              "info",
            ],
          },
        },
      },
      () => {
        this.getClientPaymentInfo();
      }
    );
  }

  async getClientPaymentInfo() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/clientpayments `;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          //console.log("response data",response);
          let data = response.data.object;
          if (response.status === 200 && data.length > 0) {
            //console.log(data);
            this.setState({
              data: data,
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientPaymentInfo();
      }
    }
  }

  async refereshData() {
    const { pageNumber, pageSize } = this.state.pageOptions.pageOptions;
    const { srchClient, toDate, formDate } = this.state.searchparam;

    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/getclientpayments?rows=${pageSize}&page=${pageNumber}&clientname=${srchClient}&fromdate=${getFormattedDate(
      formDate
    )}&todate=${getFormattedDate(toDate)}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          let data = response.data.rows;
          if (response.status === 200 && data.length > 0) {
            this.setState({
              data: data,
              pageOptions: {
                pageOptions: {
                  pageSize: Math.min(10, 50, 30, 100, data.length),
                  total: response.data.total,
                  pageList: [10, 50, 30, 100, data.length].sort(function (
                    a,
                    b
                  ) {
                    return a - b;
                  }),
                  ...this.state.pageOptions.pageOptions,
                },
                loading: false,
              },
            });
          } else {
            this.setState({
              pageOptions: {
                pageOptions: { ...this.state.pageOptions.pageOptions },
                loading: false,
              },
            });
          }
        })
        .catch((error) => {
          this.setState({
            pageOptions: {
              pageOptions: {
                ...this.state.pageOptions.pageOptions,
              },
              loading: false,
            },
          });
        });
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.refereshData();
      }
    }
  }

  onPageChange(event) {
    //delete event["refresh"];
    delete event["filterRules"];
    //console.log(event);
    this.setState(
      {
        pageOptions: {
          pageOptions: { ...this.state.pageOptions.pageOptions, ...event },
          loading: true,
        },
      },
      function () {
        this.refereshData();
      }
    );
  }

  searchFieldOnChange(name, e) {
    let searchparam = Object.assign({}, this.state.searchparam);
    searchparam[name] = e;
    this.setState({ searchparam: searchparam });
  }

  render() {
    const searchparam = this.state.searchparam;
    const styles = { width: 110, height: 30 };
    return (
      <div>
        <Panel
          title='Clients Payment List'
          bodyStyle={{ padding: 0 }}
          style={{ height: 567 }}
        >
          <DataGrid
            data={this.state.data}
            style={{ height: 500 }}
            selectionMode='single'
            {...this.state.pageOptions}
            pagination
            onPageChange={this.onPageChange}
            {...this.props.selectedRow}
            onSelectionChange={(selection) =>
              this.props.onSelectionChange(selection)
            }
            toolbar={({ editingItem }) => (
              <div style={{ padding: 4 }}>
                <b>Client Name </b>&nbsp;
                <ComboBox
                  style={{ width: 200 }}
                  data={this.props.clientsList}
                  valueField='organizationname'
                  textField='organizationname'
                  value={searchparam.srchClient}
                  onChange={(e) => this.searchFieldOnChange("srchClient", e)}
                ></ComboBox>
                &nbsp;
                <b>From Date:</b>&nbsp;
                <DateBox
                  inputId='d1'
                  format='yyyy-MM-dd'
                  value={searchparam.formDate}
                  style={styles}
                  calendarOptions={{
                    validator: (date) => {
                      var now = new Date();
                      var d1 = new Date(
                        now.getFullYear(),
                        now.getMonth(),
                        now.getDate()
                      );

                      return d1 >= date;
                    },
                  }}
                  panelStyle={{ width: 250, height: 300, margin: "auto" }}
                  onChange={(e) => this.searchFieldOnChange("formDate", e)}
                ></DateBox>
                &nbsp;
                <b>To Date:</b>&nbsp;
                <DateBox
                  inputId='d1'
                  format='yyyy-MM-dd'
                  value={searchparam.toDate}
                  style={styles}
                  calendarOptions={{
                    validator: (date) => {
                      var now = new Date();
                      var d1 = new Date(
                        now.getFullYear(),
                        now.getMonth(),
                        now.getDate()
                      );

                      return d1 >= date;
                    },
                  }}
                  panelStyle={{ width: 250, height: 300, margin: "auto" }}
                  onChange={(e) => this.searchFieldOnChange("toDate", e)}
                ></DateBox>
                &nbsp;
                <LinkButton
                  iconCls='icon-search'
                  plain
                  onClick={this.refereshData}
                >
                  Search
                </LinkButton>
                {this.props.permissions.includes("client-payment-edit") ? (
                  <LinkButton
                    iconCls='icon-edit'
                    plain
                    disabled={isEmpty(this.props.selectedRow)}
                    onClick={this.props.OnEditClick}
                  >
                    Edit
                  </LinkButton>
                ) : (
                  ""
                )}
              </div>
            )}
          >
            <GridColumn
              field='rn'
              align='center'
              width='30px'
              cellCss='datagrid-td-rownumber'
              render={({ rowIndex }) => <span>{rowIndex + 1}</span>}
            />

            <GridColumn field='clientid' title='Client Id'></GridColumn>
            <GridColumn field='clientname' title='Name'></GridColumn>
            <GridColumn
              field='entrydate'
              title='Entry Date'
              render={({ row }) => (
                <span>{getFormattedDate(row.entrydate)}</span>
              )}
            ></GridColumn>
            <GridColumn field='transactiontype' title='Type'></GridColumn>
            <GridColumn field='amount' title='Amount'></GridColumn>
          </DataGrid>
        </Panel>
      </div>
    );
  }
}
